import { Box, Paper } from "@mui/material";
import React, { Suspense, useEffect } from "react";
import SideBar from "./SideBar";
import { Navigate, Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { printRequestsTodayUrl } from "../../utils/urls";
import { addRequest, setRequests } from "../../store/printRequestSlice";
import { toast } from "react-toastify";
import axiosInstance from "../../utils/axiosInstance";
import axios from "axios";
import LoadingUI from "../LoadingUI";
import PageSkeleton from "../skeletons/PageSkeleton";

const LayoutWrapper = ({ children }) => {
  const dispatch = useDispatch();

  const token = useSelector((state) => state.auth.token);
  const vendorData = useSelector((state) => state.auth.vendorData);
  const isAuthenticated = true;
  // const isAuthenticated = !!token

  console.log({ isAuthenticated });

  useEffect(() => {
    if (isAuthenticated && token) {
      const storeId = vendorData.stores[0]?.id;
      if (!storeId) return;

      const url = `${printRequestsTodayUrl}?store_id=${storeId}&token=${token}`;
      const eventSource = new EventSource(url);

      eventSource.onmessage = (event) => {
        const data = JSON.parse(event.data);
        console.log("Received event:", data);

        if (Array.isArray(data)) {
          dispatch(setRequests(data));
        } else {
          dispatch(addRequest(data));
          toast.success(
            `${data?.customer?.name || "Customer"} requested print request!`
          );
        }
      };

      eventSource.onerror = (error) => {
        console.error("EventSource error:", error);
        eventSource.close();
      };

      return () => {
        eventSource.close();
      };
    }
  }, [isAuthenticated, token, vendorData]);

  if (!isAuthenticated) {
    // Redirect to login page if not authenticated
    return <Navigate to="/login" replace />;
  }

  return (
    <Box display={"flex"} height={"100vh"} overflow={"hidden"}>
      <SideBar />
      <Box
        component={Paper}
        flex={1}
        px={3}
        py={2}
        sx={{
          overflowX: "auto",
          borderRadius: 0,
          background:
            "linear-gradient(to bottom,rgba(255, 213, 0, 0.09) 0%,rgba(255, 255, 255, 0) 20%)",
        }}
      >
        <Suspense fallback={<PageSkeleton />}>
          <Outlet />
        </Suspense>
      </Box>
    </Box>
  );
};

export default LayoutWrapper;
